if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if(!this.hasAttribute('available')) return;

      this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId, this.dataset.variantIsbn);
    }

    getBNAvailability(position, variantId, isbn) {

      console.log(position);
      var lat = "";
      var lon = "";
      if (position != null ){
        lat = position.coords.latitude;
        lon = position.coords.longitude;
      } else {
        lat = "";
        lon = "";
      }

      console.log(lat);
      console.log(lon);
      
      const data = {
        lat: lat,
        lon: lon,
        isbn: isbn
      }


      //First refresh the shopify section so that we have everything in the DOM
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          console.log("Refreshed section");
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML, data);
        })
        .catch(e => {
          console.log("ERROR RENDERING SHOPIFY SECTION")
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    fetchAvailability(variantId, isbn) {
      console.log(isbn);
      // console.log("Availability drawer:");
      // console.log(document.querySelector('pickup-availability-drawer'));
      const thing = this;

      //6 December 2022 - Jumping straight to get availability rather than asking or location - testing if it impacts CRO
      thing.getBNAvailability(null, variantId, isbn);

    }
      
	  soh(data) {

      // reset drawer
      // const drawer = document.querySelector('pickup-availability-drawer');
      // if (drawer) drawer.remove();

      if (data == "") {
        console.log("WARNING - SoH data is blank. This needs to be handled in pickup-availabilities.js")
        // this.innerHTML = "";
        // this.removeAttribute('available');
        // return;
      }

      //The original script refreshes the section and then rerenders the pickup preview and drawer.
      // The new script just needs to check BW SoH and then manipulate preview and drawer accordingly.
      // The drawer initially loads with all stores, waiting to be parsed by the script based on result from BW SoH
      // this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
      // this.setAttribute('available', '');

      // document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

      //Make sure the button click event is attached - this was originally required because we were rerendering the section
      const button = this.querySelector('button');
      if (button) button.addEventListener('click', (evt) => {
        document.querySelector('pickup-availability-drawer').show(evt.target);
      });

      const store_array = data;
      const locations_arr = store_array;

      //const soh = obj.includes("webstore") ? true : false;
      console.log("locations_arr");
      console.log(locations_arr);
      //console.log(soh);

      const locations_list_items = document.getElementsByClassName("pickup-availability-list__item");

      console.log("location list items");
      console.log(locations_list_items);
  
      const items = Array.prototype.slice.call(locations_list_items);
  
      console.log("pre-sort");
      console.log(items);
  
      items.sort(function(a, b){
        //use findIndex to get the index based on the store object within the array
        // console.log("The value for " + a.id + " will be: " + locations_arr.findIndex(l => l.store === b.id));
  
        // if (locations_arr.findIndex(l => l.store === a.id) > locations_arr.findIndex(l => l.store === b.id)) {
        //   return 1;
        // }else if(locations_arr.findIndex(l => l.store === a.id) < locations_arr.findIndex(l => l.store === b.id)) {
        //   return -1;
        // }else{
        //   return 0;
        // }
        return locations_arr.findIndex(l => l.store === a.id) - locations_arr.findIndex(l => l.store === b.id)
        // return locations_arr.indexOf(a.id) - locations_arr.indexOf(b.id);
      });
  
      // console.log("This should be a sorted list:");
      // console.log(items);

      var available_locations = [];
      var unavailable_locations = [];

      for(var i = 0, len = items.length; i < len; i++) {
        // store the parent node so we can reatach the item
        var parent = items[i].parentNode;

        // detach it from wherever it is in the DOM
        var detatchedItem = parent.removeChild(items[i]);

        // reatach it.  This works because we are itterating
        // over the items in the same order as they were re-
        // turned from being sorted.
        // debugger;
    
        //closestLocationPreview
        
        if (locations_arr.findIndex(l => l.store === detatchedItem.id) >= 0) {
          detatchedItem.classList.remove("hidden");
          available_locations.push(detatchedItem);
          parent.appendChild(detatchedItem);
          //consider using css classes to show/hide or indicate availability, rather than removing from DOM
        }else{
          detatchedItem.classList.add("hidden");
          unavailable_locations.push(detatchedItem);
          parent.appendChild(detatchedItem);
        }

      }

      if(available_locations.length > 0){
        const button = this.querySelector('button');
        if(button) {
          
          const addButtonText = button.querySelector('span');
          const reserveIcon = button.querySelector('svg');
          addButtonText.textContent = "Reserve in-store"
          reserveIcon.classList.remove("hidden");
          button.removeAttribute('disabled', 'disabled');
        };
        this.classList.remove("hidden");
      }else{
        // this.innerHTML = "";
        const button = this.querySelector('button');
        if(button) {
          const addButtonText = button.querySelector('span');
          const reserveIcon = button.querySelector('svg');
          addButtonText.textContent = "Unavailable in-store"
          reserveIcon.classList.remove("hidden");
          button.setAttribute('disabled', 'disabled');
        };
        return;
      }

    }


    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId, this.dataset.variantIsbn);
    }

    renderError() {
      console.log("RENDERING ERROR");
      this.innerHTML = '';
      this.appendChild(this.errorHtml);

      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      this.classList.remove("hidden");
    }

    renderPreview(sectionInnerHTML, data) {
      console.log("Rendering preview");
      const drawer = document.querySelector('pickup-availability-drawer');
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
      this.setAttribute('available', '');

      document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

      const button = this.querySelector('button');
      if (button) button.addEventListener('click', (evt) => {
        document.querySelector('pickup-availability-drawer').show(evt.target);
      });



      // var url = new URL("https://kszv4pah7ve42qejcpw3v7jfe40wcqba.lambda-url.ap-southeast-2.on.aws");
      var url = new URL("https://3lb5xgt6k2yjymli2kgha74bhu0jzzwh.lambda-url.ap-southeast-2.on.aws"); 
      for (let k in data) {
        url.searchParams.append(k, data[k]);
      }

      fetch(url)
        .then(response => response.json())
        .then(data => this.soh(data))
        .catch (e => {
          const button = this.querySelector('button');
          console.log("Error fetching BW data: " + e)
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
      // .catch(e => {
      //   const button = this.querySelector('button');
      //   console.log("Error fetching BW data: " + e)
      //   if (button) button.removeEventListener('click', this.onClickRefreshList);
      //   this.renderError();
      // });




    }
  });
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();

      this.onBodyClick = this.handleBodyClick.bind(this);

      this.querySelector('button').addEventListener('click', () => {
        this.hide();
      });

      this.addEventListener('keyup', (event) => {
        if(event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') {
        this.hide();
      }
    }

    hide() {
      this.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClick);
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.focusElement);
    }

    show(focusElement) {
      this.focusElement = focusElement;
      this.setAttribute('open', '');
      document.body.addEventListener('click', this.onBodyClick);
      document.body.classList.add('overflow-hidden');
      trapFocus(this);
    }
  });
}
